module.exports = __webpack_public_path__ + "static/media/ending-light-line.4996e376.png";